import type {
  OperatorPortfolioPropertiesDto,
  PortfolioPropertyDto,
} from './operator-portfolio.types';

function buildProperties(): PortfolioPropertyDto[] {
  const templates: Omit<PortfolioPropertyDto, 'id'>[] = [
    {
      location: 'Horizon Mall',
      chargerCount: 16,
      ownership: 'owned',
      contractStatus: 'breach',
      businessImpactTone: 'high',
      businessImpactLabel: 'High traffic',
      needsAttention: true,
    },
    {
      location: 'East Paris Hotel',
      chargerCount: 8,
      ownership: 'managed',
      contractStatus: 'late',
      businessImpactTone: 'medium',
      businessImpactLabel: 'Guest service',
      needsAttention: true,
    },
    {
      location: 'Lyon Logistics Hub',
      chargerCount: 24,
      ownership: 'owned',
      contractStatus: 'late',
      businessImpactTone: 'medium',
      businessImpactLabel: 'Guest service',
      needsAttention: true,
    },
    {
      location: 'Commune A',
      chargerCount: 12,
      ownership: 'managed',
      contractStatus: 'on_track',
      businessImpactTone: 'low',
      businessImpactLabel: 'Within contract',
      needsAttention: false,
    },
    {
      location: 'Commune B',
      chargerCount: 10,
      ownership: 'owned',
      contractStatus: 'on_track',
      businessImpactTone: 'low',
      businessImpactLabel: 'Within contract',
      needsAttention: false,
    },
    {
      location: 'Commune E',
      chargerCount: 14,
      ownership: 'managed',
      contractStatus: 'breach',
      businessImpactTone: 'high',
      businessImpactLabel: 'High traffic',
      needsAttention: true,
    },
    {
      location: 'Nantes Central',
      chargerCount: 9,
      ownership: 'owned',
      contractStatus: 'on_track',
      businessImpactTone: 'low',
      businessImpactLabel: 'Within contract',
      needsAttention: false,
    },
    {
      location: 'Bordeaux Quay',
      chargerCount: 11,
      ownership: 'managed',
      contractStatus: 'late',
      businessImpactTone: 'medium',
      businessImpactLabel: 'Guest service',
      needsAttention: true,
    },
    {
      location: 'Lille Station',
      chargerCount: 7,
      ownership: 'owned',
      contractStatus: 'on_track',
      businessImpactTone: 'low',
      businessImpactLabel: 'Within contract',
      needsAttention: false,
    },
    {
      location: 'Toulouse Arena',
      chargerCount: 18,
      ownership: 'managed',
      contractStatus: 'breach',
      businessImpactTone: 'high',
      businessImpactLabel: 'High traffic',
      needsAttention: true,
    },
    {
      location: 'Marseille Port',
      chargerCount: 20,
      ownership: 'owned',
      contractStatus: 'on_track',
      businessImpactTone: 'low',
      businessImpactLabel: 'Within contract',
      needsAttention: false,
    },
    {
      location: 'Rennes Campus',
      chargerCount: 6,
      ownership: 'managed',
      contractStatus: 'on_track',
      businessImpactTone: 'low',
      businessImpactLabel: 'Within contract',
      needsAttention: false,
    },
    {
      location: 'Strasbourg Hub',
      chargerCount: 13,
      ownership: 'owned',
      contractStatus: 'late',
      businessImpactTone: 'medium',
      businessImpactLabel: 'Guest service',
      needsAttention: true,
    },
    {
      location: 'Nice Promenade',
      chargerCount: 8,
      ownership: 'managed',
      contractStatus: 'on_track',
      businessImpactTone: 'low',
      businessImpactLabel: 'Within contract',
      needsAttention: false,
    },
  ];

  // Pad to 28 sites for pagination demo (Page 1 of 5 at 6/page).
  const properties: PortfolioPropertyDto[] = [];
  for (let i = 0; i < 28; i += 1) {
    const template = templates[i % templates.length]!;
    properties.push({
      ...template,
      id: `site-${i + 1}`,
      location:
        i < templates.length
          ? template.location
          : `${template.location} ${Math.floor(i / templates.length) + 1}`,
    });
  }
  return properties;
}

/** Property rows stay mocked: ownership and contract labels are not on Asset/Site. */
export const OPERATOR_PORTFOLIO_PROPERTIES_MOCK: OperatorPortfolioPropertiesDto =
  {
    properties: buildProperties(),
    alert: {
      id: 'alert-horizon-breach',
      message:
        'Horizon Mall breach: High traffic location with €1,800 penalty. Review contract compliance and escalation plan.',
    },
  };
